import axios from 'axios';

const createUtterance = ({ faqId, utterance }) =>
  axios.post(`faqs/${faqId}/utterances`, utterance);

const updateUtterance = ({ faqId, utteranceId, utterance }) =>
  axios.put(`faqs/${faqId}/utterances/${utteranceId}`, utterance);

const deleteUtterance = ({ faqId, utteranceId }) =>
  axios.delete(`faqs/${faqId}/utterances/${utteranceId}`);

const deleteUtterances = ({ faqId, utteranceIds }) =>
  axios.put(`faqs/${faqId}/utterances/delete`, utteranceIds);

const createUtterancesBulk = ({ faqId, languageId, utterances }) =>
  axios.post(`faqs/${faqId}/utterances/bulk`, {
    language_id: languageId,
    utterances
  });

export {
  createUtterance,
  updateUtterance,
  deleteUtterance,
  deleteUtterances,
  createUtterancesBulk
};
